import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { TrackManager } from "@x-mile/api-contract";
import type { GetCompanyParams } from "../model";

export const useGetCompany = (
  params: GetCompanyParams,
  options?: QueryOptions<typeof TrackManager.useGetCompany>,
): UseQueryResult<TrackManager.GetCompanyQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getCompany", keysToSnakeCase(params)],
    queryFn: () =>
      TrackManager.getCompany(
        params.id,
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    TrackManager.GetCompanyQueryResult,
    undefined
  >;
};

export const useMultipleGetCompany = (
  paramsList: { [key: string | number]: GetCompanyParams },
  options?: QueryOptions<typeof TrackManager.useGetCompany> & {
    sortFunc?: (a: GetCompanyParams, b: GetCompanyParams) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    TrackManager.GetCompanyQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getCompany", keysToSnakeCase(params)],
        queryFn: () =>
          TrackManager.getCompany(
            params.id,
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      TrackManager.GetCompanyQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetCompanyMock = (
//   params: GetCompanyParams,
//   options?: QueryOptions<typeof TrackManager.useGetCompany>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await TrackManager.startMockServerWoker(
//         TrackManager.getGetCompanyMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetCompany(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetCompanyMock = (
//   paramsList: { [key: string | number]: GetCompanyParams },
//   options?: QueryOptions<typeof TrackManager.useGetCompany>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await TrackManager.startMockServerWoker(
//         TrackManager.getGetCompanyMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetCompany(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
